import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { splitStringEqually } from '../../../../utils/utils';

const BgIcon = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: -30px;
  background-image: url('/icons/logo.svg');
  background-repeat: no-repeat;
  background-position: top -220px right -200px;
  background-size: 1000px;
`;

const StyledDiv = styled.div`
  display: flex;
  ${(props) =>
    props.$topHalfColor && props.$bottomHalfColor
      ? `
    background: linear-gradient(to bottom, 
      ${props.$topHalfColor} 15%, 
      ${props.$topHalfColor} 30%, 
      ${props.$topHalfColor} 50%, 
      ${props.$bottomHalfColor} 50.1%, 
      ${props.$bottomHalfColor} 65%, 
      ${props.$bottomHalfColor} 80%, 
      ${props.$bottomHalfColor} 100% 
    );
    `
      : `
      background-color: inherit;
    `}
`;

const SystemRightForMe = forwardRef(
  (
    { section, dark, topHalfColor, bottomHalfColor, link, openModalForm },
    ref
  ) => {
    const textArrays = splitStringEqually(section.componentData.title);
    return (
      <StyledDiv
        $topHalfColor={topHalfColor}
        $bottomHalfColor={bottomHalfColor}
        ref={ref}
      >
        <div className="flex w-full flex-col flex-1 lg:mx-auto max-w-7xl my-10 md:my-20">
          <div
            className={`flex flex-col md:flex-row relative ${dark ? 'bg-primary-900' : 'bg-primary-800'} mx-8 rounded-[32px] px-5 py-8 sm:p-10 md:p-20 gap-10 lg:gap-20`}
          >
            <BgIcon />
            <Stack className="flex flex-1 md:flex-[0.5] gap-5">
              <Typography
                as="h3"
                fontVariant="h4"
                textAlign="left"
                className="!text-white leading-[2rem]"
              >
                {textArrays[0]}
                <span className="text-secondary-400">
                  <br />
                  {textArrays[1]}
                </span>
              </Typography>
              <Typography
                fontVariant="lg"
                textAlign="left"
                className="!text-white opacity-75"
              >
                {section.componentData.text}
              </Typography>
            </Stack>
            <Stack className="flex-1 md:flex-[0.5] justify-center items-center">
              <LinkButton
                label={section.componentData.buttonText}
                href={link || null}
                onClick={openModalForm || null}
                textTransform="uppercase"
                size="lg"
                className="w-fit z-20 bg-primary-500"
              />
            </Stack>
          </div>
        </div>
      </StyledDiv>
    );
  }
);

export default SystemRightForMe;
